"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spinner;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSpring = require("react-spring");
var _svgs = _interopRequireWildcard(require("svgs"));
var _styles = require("@sart/styles");
var _excluded = ["size", "color", "duration"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var totalPathLength = 282.28662109375;
var AnimatedCircle = (0, _reactSpring.animated)(_svgs.Circle);
function Spinner(props) {
  var size = props.size,
    color = props.color,
    duration = props.duration,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var pathProps = (0, _reactSpring.useSpring)({
    from: {
      strokeDashoffset: totalPathLength
      // transform: 'rotate3d(0deg)',
    },
    // to: async next => {
    //   while (1)
    //     await next({
    //       strokeDashoffset: -totalPathLength,
    //       // transform: 'rotate3d(360deg)',
    //     })
    // },
    to: {
      strokeDashoffset: -totalPathLength
      // transform: 'rotate3d(360deg)',
    },
    config: {
      duration: duration ? duration : 2000
    },
    reset: true
  });
  return /*#__PURE__*/_react["default"].createElement(_svgs["default"], {
    viewBox: "-48 -48 96 96",
    width: size,
    height: size
  }, /*#__PURE__*/_react["default"].createElement(AnimatedCircle, (0, _extends2["default"])({
    cx: "0",
    cy: "0",
    r: "44",
    fill: "none",
    stroke: color ? color : _styles.colors.subtle,
    strokeWidth: "8",
    strokeLinecap: "round",
    strokeDasharray: totalPathLength + ' ' + totalPathLength,
    transform: "rotate(-90)"
  }, pathProps, rest)));
}
Spinner.defaultProps = {
  size: 96
};
Spinner.propTypes = {
  size: _propTypes["default"].any
};